import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import RoleCreateViewModel from "viewModels/users/roles/roleCreateViewModel";
import CreateView from "../../common/create";
import RoleForm from "./roleForm";

const RoleCreateView: ViewComponent<RoleCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<RoleForm vm={vm} />} />
));

registerView(RoleCreateView, RoleCreateViewModel);
